import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, getFormValues } from 'redux-form';

import { accountSearchFormCriteriaValidation, isFindAccountButtonEnabled, validate } from './validation/validation';
import { findTouchedField } from './status/status';
import { fetchCustomerAccounts } from '../../store/actions/accountActions';

import formFields from '../../util/formFields';
import { renderField } from './renderField';

import './forms.css';

export class AccountSearchForm extends Component {
  constructor(props) {
    super(props);
    this.titleRef = React.createRef();
    this.didFocusTitleRef = false;
  }

  componentDidMount() {
    if (this.titleRef.current && !this.didFocusTitleRef) {
      this.titleRef.current.focus();
      this.didFocusTitleRef = true;
    }
  }

  static isSubmitEnabled(formData, isInvalid) {
    let isEnabled = isFindAccountButtonEnabled(formData, isInvalid);
    return {
      isEnabled,
    };
  }

  static renderFieldComponent(name, label, validation, disabled) {
    return (
      <Field
        key={name}
        label={label}
        name={name}
        classname={'AccountSearchForm-field search-form-field'}
        component={renderField}
        validate={validation}
        disabled={disabled}
      />
    );
  }

  renderFormFields(items, touchedField, formValues) {
    let theTouchedField = touchedField ? accountSearchFormCriteriaValidation(touchedField, formValues) : '';
    if (theTouchedField) {
      return items.map(({ label, name, validation }) => {
        if (!theTouchedField.includes(name)) {
          return AccountSearchForm.renderFieldComponent(name, label, validation, true);
        }
        return AccountSearchForm.renderFieldComponent(name, label, validation, false);
      });
    } else {
      return items.map(({ label, name, validation }) => {
        return AccountSearchForm.renderFieldComponent(name, label, validation, false);
      });
    }
  }

  render() {
    const { reset, formData, handleSubmit, invalid, fetchCustomerAccounts, formValues } = this.props;
    const {
      searchAccountFields: { leftSide, rightSide },
    } = formFields;
    const { isEnabled } = AccountSearchForm.isSubmitEnabled(formData, invalid);
    const touchedField = findTouchedField(formData, formValues);

    return (
      <div className="account-search-container">
        <h1 ref={this.titleRef} className="searchFormTitle" tabIndex={-1}>
          Customer Account Manual Search Criteria:
        </h1>
        <form className="accountSearchForm" onSubmit={handleSubmit(fetchCustomerAccounts)}>
          <div className="row">
            <div className="column">{this.renderFormFields(leftSide, touchedField, formValues)}</div>
            <div className="column">{this.renderFormFields(rightSide, touchedField, formValues)}</div>
          </div>
          <button
            className="search-button mrg-rgt"
            disabled={!isEnabled}
            type="submit"
            aria-label={isEnabled ? 'Required fields are entered. Some form fields disabled.' : ''}
          >
            Search Account
          </button>
          <button className="search-button" onClick={reset} type="reset">
            Clear
          </button>
        </form>
      </div>
    );
  }
}

AccountSearchForm = reduxForm({
  form: 'accountSearchForm',
  enableReinitialize: true,
  touchOnChange: false,
  validate,
})(AccountSearchForm);

AccountSearchForm = connect(
  reactState => {
    const selector = formValueSelector('accountSearchForm');
    const {
      PhoneNumber,
      AccountNumber,
      ApartmentNumber,
      LastName,
      FirstName,
      Username,
      CompanyName,
      StreetNumber,
      StreetName,
      Zip,
      City,
      State,
    } = selector(
      reactState,
      'PhoneNumber',
      'AccountNumber',
      'ApartmentNumber',
      'LastName',
      'FirstName',
      'Username',
      'CompanyName',
      'StreetNumber',
      'StreetName',
      'Zip',
      'City',
      'State'
    );
    return {
      formValues: getFormValues('accountSearchForm')(reactState),
      formData: {
        PhoneNumber,
        AccountNumber,
        ApartmentNumber,
        LastName,
        FirstName,
        Username,
        CompanyName,
        StreetNumber,
        StreetName,
        Zip,
        City,
        State,
      },
    };
  },
  { fetchCustomerAccounts }
)(AccountSearchForm);

export default AccountSearchForm;
